import { render, staticRenderFns } from "./bill.vue?vue&type=template&id=8af6b350&scoped=true&"
import script from "./bill.vue?vue&type=script&lang=js&"
export * from "./bill.vue?vue&type=script&lang=js&"
import style0 from "./bill.vue?vue&type=style&index=0&id=8af6b350&prod&lang=scss&scoped=true&"
import style1 from "./bill.vue?vue&type=style&index=1&id=8af6b350&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af6b350",
  null
  
)

export default component.exports